"use client"

import * as React from "react";
import {useContext, useEffect, useState} from "react";
import ApplyCoupon from './actions/apply-coupon';
import RemoveCoupon from './actions/remove-coupon';
import {Basket} from "../../../context/basket";
import { toast } from 'react-toastify';
import Grid from "@mui/material/Unstable_Grid2";

const Coupon = (props) =>
{
    const basket = useContext(Basket);
    const setLoader = props.setLoader;
    const setLoadingMessage = props.setLoadingMessage;
    const path = props.path;
    const [show, setShow] = useState(false);
    const [discountCode, setDiscountCode] = useState('');
    const [showCouponField, setShowCouponField] = useState(true);
    const [activeCoupon, setActiveCoupon] = useState(false);

    const showOrHideCoupon = (e) => {
        if (!show) {
            setShow(true);
        } else {
            setShow(false);
        }
    }

    const elementDisabled = () => {
        if (activeCoupon !== false) {
            return true;
        }

        return false;
    }

    const setDiscountCodeAction = (e) => {
        const target = e.currentTarget;
        setDiscountCode(target.value);
    }

    const applyCoupon = (e) => {
        if (discountCode === '') {
            toast.error('Please add a discount code.');
            setLoader(false);
        } else if (activeCoupon !== false) {
            setLoadingMessage('Removing discount code...');
            setLoader(true);
            RemoveCoupon().then((res) => {
                if (res.data.error) {
                    setLoader(false);
                    toast.error(res.data.message);
                } else {
                    toast.success(res.data.message);
                    basket.updateBasketReturn().then(() => {
                        setLoader(false);
                    });
                }
            });
        } else {
            setLoadingMessage('Applying discount code...');
            setLoader(true);
            ApplyCoupon(discountCode).then((res) => {
                if (res.data.error) {
                    setLoader(false);
                    toast.error(res.data.message);
                } else {
                    toast.success(res.data.message);
                    basket.updateBasketReturn().then(() => {
                        setLoader(false);
                    });
                }
            });
        }
    }

    useEffect(() => {
        if (props.path === 'payment' && showCouponField === true) {
            setShowCouponField(false);
        } else if (showCouponField === false) {
            setShowCouponField(true);
        }

        // Fill up the discount code field from the quote if the checkout gets reloaded.
        if (basket?.data?.quote?.quote?.discount_codes !== null) {
            try {
                const activeCodes = JSON.parse(basket?.data?.quote?.quote?.discount_codes);
                if (discountCode !== activeCodes[0]) {
                    setDiscountCode(activeCodes[0]);
                    setShow(true);
                    setShowCouponField(true);
                    if (typeof props.setShowDiscountField !== 'undefined') {
                        props.setShowDiscountField(true);
                    }
                    setActiveCoupon(activeCodes[0]);
                }
            } catch (e) {}
        }
    }, [props.path]);

    return <div className="coupon-wrapper">
        {showCouponField && (
            <div className="discount_input_div">
                <div id="discount-field" className="discount-field">
                    <div className="discount_switch">
                        <p className="field__error-message" style={{display: 'none'}}>error info</p>
                            <Grid container className="align-baseline">
                                <Grid xs={12} md={8}>
                                    <input id="checkout_discount_code"
                                           className="discount_code boxed"
                                           name="discount_code"
                                           placeholder="Enter your discount code:"
                                           size="30"
                                           style={{marginBottom: 0}}
                                           type="text"
                                           value={discountCode}
                                           onChange={setDiscountCodeAction}
                                           disabled={elementDisabled()}
                                    />
                                </Grid>
                                <Grid xs={12} md={4} className="padding-desktop-left-1">
                                    <button className="button margin-tablet-top-1" type="button"
                                            onClick={applyCoupon}>
                                        {activeCoupon !== false && (
                                            <>Remove</>
                                        )}
                                        {activeCoupon === false && (
                                            <>Apply</>
                                        )}
                                    </button>
                                </Grid>
                            </Grid>
                    </div>
                </div>
            </div>
        )}
    </div>
}

export default Coupon;